import { ActiveAppState } from "../components/App/AppProvider"

export const isJobsAccount = (appState : ActiveAppState) => appState.app.accountInfo?.isJobsUser || false;

export default isJobsAccount;